import { createSelector } from 'reselect';
import {
  makeEntityAdapter,
  makeFetchNew,
  makeInitialState,
  makeSelectors,
  makeSlice,
} from '../appcontent/appcontent.utils';
import { selectData } from '../data.selectors';
import {
  filterOffers,
  makeDeleteOffer,
  makeFetchOffers,
  makeUpdateOffer,
} from './offers.utils';

const sliceName = 'data/offers';

const entityAdapter = makeEntityAdapter('distributedOfferId');

export const selectors = makeSelectors(
  'Offers',
  'offers',
  selectData,
  entityAdapter,
);

selectors.selectAllFiltered = createSelector(selectors.selectAll, filterOffers);

selectors.selectTotalFiltered = createSelector(
  selectors.selectAllFiltered,
  filteredOffers => filteredOffers.length,
);

const fetchOffers = makeFetchOffers(
  sliceName,
  () => slice.actions,
  selectors,
  false,
);

const refreshOffers = makeFetchNew(
  `${sliceName}/refreshOffers`,
  '/appoffers',
  response => slice.actions.upsertMany(response.data?.offerList?.offers ?? []),
  response => response.data?.offerList?.offers,
  {
    count: 10,
    languageCode: 'EN',
    page: 1,
    loyalty: false,
  },
);

export const initialState = makeInitialState(entityAdapter);

export const slice = makeSlice(
  sliceName,
  initialState,
  entityAdapter,
  fetchOffers,
  refreshOffers,
);

const deleteOffer = makeDeleteOffer(sliceName, slice.actions.removeOne);

const updateOfferStatus = makeUpdateOffer(sliceName, slice.actions.updateOne);

export const actions = {
  ...slice.actions,
  fetchOffers,
  refreshOffers,
  deleteOffer,
  updateOfferStatus,
};

export default slice.reducer;
